import dayjs from 'dayjs';
import * as authTypes from 'redux/types/authTypes';
import { authType } from 'redux/types/storeTypes';

const initialState: authType = {

  accessToken: undefined,

  user: undefined,

};

const expiresAt = () => {

  return dayjs(new Date()).add(1, "day");

}


const authReducer = (state = initialState, action: { [key: string]: any }) => {
  switch (action.type) {
    case authTypes.LOGIN_SUCCESS:
      return {
        ...state,
        accessToken: action.payload?.authToken,
        expiresAt: expiresAt(),
        ...action.payload,
        loggedIn: true,
      };

    case authTypes.RESET_APP_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default authReducer;
